import type { ReactNode } from "react";
import { HORNAUT_KOPF_AVATAR } from "./hornaut-kopf";

/**
 * KiAussage (W104 A, AW-076, Design-Guide `ki-aussage.md`): eine Aussage der KI mit dem Hornaut-Kopf als Absender.
 * Blase in KI-Violett (`ki-soft` + `ki-line`), Label „{absender} sagt“ in `ki-text`, Inhalt in `text-foreground`.
 * `absender` fehlt in der KiKarte, weil der Kartenkopf ihn nennt (dann steht kein Label in der Blase).
 *
 * R-D: die Wurzel trägt `ai-gated` + `data-ki="aussage"`. Der Aufrufer zeigt die Aussage nur, wenn der Text wirklich von
 * der KI stammt; bei KI aus (Fallback) und für Regelsätze/menschlich verantwortete Inhalte bleibt der Ersatz neutral
 * (kein Violett, kein Kopf). Der Kopf ist dekorativ (`alt=""`), Name oder Label stehen immer als Text daneben.
 */
export function KiAussage({ absender, children, hinweis }: { absender?: string; children: ReactNode; hinweis?: ReactNode }) {
  return (
    <>
      {/* Preline: communication/communication-sub-chat-inbox/communication-cat-ai-chat-bubbles/long-form-ai-response-bubble-with-feedback-actions-and-sources-button */}
      <div className="ai-gated flex gap-x-2.5 items-start" data-ki="aussage">
        {/* Avatar-Kopf nach dem Muster des Blocks oben (runder Avatar vor der Blase); Bild = Hornaut-Kopf der Marke */}
        {/* eslint-disable-next-line @next/next/no-img-element -- statisches Kopf-Bild der Marke */}
        <img
          src={HORNAUT_KOPF_AVATAR}
          alt=""
          aria-hidden="true"
          width={24}
          height={24}
          className="shrink-0 size-6 rounded-full object-cover ring-1 ring-ki-line bg-ki-soft"
        />
        <div className="grow min-w-0 p-3 rounded-lg rounded-tl-none bg-ki-soft border border-ki-line">
          {absender && <p className="text-xs font-medium text-ki-text">{absender} sagt</p>}
          <div className={absender ? "mt-1 text-sm text-foreground" : "text-sm text-foreground"}>{children}</div>
          {hinweis && <p className="mt-1.5 text-xs text-muted-foreground-1">{hinweis}</p>}
        </div>
      </div>
    </>
  );
}
